import { useTranslation } from 'react-i18next';
import { useUserRoles } from '@anytag/auth';
import { BaseModal, BaseModalProps } from '@anytag/shared-atoms';

export interface ApproveModalProps extends BaseModalProps {
  loading?: boolean;
  isTtcmCampaign?: boolean;
  onUpdateStatus?: () => void;
}

export const ApproveModal = ({
  onClose,
  footer: actions,
  loading,
  onUpdateStatus,
  isTtcmCampaign,
  ...restProps
}: ApproveModalProps) => {
  const { t } = useTranslation();
  const { isAdminStaff } = useUserRoles();

  return (
    <BaseModal
      onClose={onClose}
      title={t('Approve Proposal')}
      description={
        isAdminStaff && isTtcmCampaign
          ? t('TTCM invitations will be sent to creators through AnyCreator')
          : t('Are you sure you want to approve?')
      }
      footer={{
        cancelButton: { onClick: onClose, ...actions?.cancelButton },
        submitButton: {
          loading,
          title: t('Button.Approve'),
          onClick: () => onUpdateStatus?.(),
          ...actions?.submitButton
        }
      }}
      {...restProps}
    />
  );
};
